import styled from 'styled-components';
import { glassEffect } from '../../theme';

export const ItemWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  margin-bottom: 10px;
  border-radius: 10px;
  gap: 15px; /* Add a gap for spacing */
  ${glassEffect};
  border: 1px solid transparent;
  border-color: ${props => (props.$status === 'Pending' ? props.theme.primary : 'transparent')};

  /* --- THIS IS THE FIX FOR NARROW SCREENS --- */
  @media (max-width: 480px) {
    flex-direction: column; /* Stack elements vertically */
    align-items: flex-start; /* Align everything to the left */
    gap: 12px; /* Adjust gap for vertical stacking */
  }
`;

export const FileLink = styled.a`
  font-weight: 500;
  color: ${({ theme }) => theme.heading};
  margin: 0;
  text-decoration: none;
  
  display: flex;
  align-items: center;
  gap: 15px;

  /* Allow the link container to shrink */
  flex: 1 1 auto;
  min-width: 0;

  &:hover {
    color: ${({ theme }) => theme.primary};
  }
`;

export const FileIcon = styled.div`
  color: ${({ theme }) => theme.text};
  flex-shrink: 0;
`;

export const FileName = styled.p`
  font-weight: 500;
  color: ${({ theme }) => theme.heading};
  margin: 0;

  /* Ensure text truncates with '...' if it's too long */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0; /* Prevent this container from shrinking */

  /* On mobile, make it take the full width for proper alignment */
  @media (max-width: 480px) {
    width: 100%;
    justify-content: space-between; /* Space out the status and buttons */
  }
`;

export const StatusDisplay = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: ${props => props.color || '#a1a1a6'};
`;

export const Thumbnail = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 6px;
  object-fit: cover;
  background-color: ${({ theme }) => theme.navActiveBg};
  flex-shrink: 0;
`;

// --- NEW STYLE FOR DOWNLOAD LINK ---
export const DownloadLinkButton = styled.a`
  display: inline-flex; /* Use inline-flex to behave like a button */
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
  border-radius: 6px;
  border: none;
  font-weight: 500;
  cursor: pointer;
  margin-left: 10px;
  min-width: 40px; /* Adjust size */
  background-color: ${({ theme }) => theme.primary};
  color: white;
  text-decoration: none;
`;

export { ActionButton } from './common.styles';